

/* ======================================================================================

Purpose: 
This file handles the logic of: 
    - add-to-project-list.liquid → Retrieves information from product and displays in PDF 
    - add-to-project-button-liquid → Updates project list with products selected (by end user)
    - add-to-project-tool.liquid → Displays the design and layout of the tool's webpage

And works with:
    - project-tool-features.liquid (new update) → Displays elements (such as variant buttons, length, product quantity) on product pages
    - project-tool-features.js (new update) → Creates the interactions of elements displayed in project-tool-features.liquid
    - project-tool.js → Creates the interactions and behaviour of design elements displayed in add-to-project-list.liquid, add-to-project-button.liquid and, add-to-project-tool.liquid

Features:
    - Removes products from the "Project List" page after 7 days has passed 
    - Adds a product to the page. 
        - Contains data on id, sku, title, image, description, quantity, productUrl
    - Updates numerical counter when products are added to the page. 
    - Renders display of page depending on page stage (empty, project list overview)
        - Dynamically changes product data used in building product card(s)
    - Supports incrementing and decrementing of product quantity
    - Deletes products 
    - Supports persistence of data when users close the tab or navigate to different pages.
    - Generates a downloadable PDF file 
    - Notifies when a product is added (or already added) to the Project List

New Features (v2.0):
    - Updates product quantity of already visited product pages (on product page, list counter and in project list page)
    - Allows users to input values into 'Quantity' and 'Length Per Metre' buttons when clicked on
    - Displays buttons for products with variants
        - When selected, button stays pressed 
        - When selected, 'Quantity' and/or 'Length per Metre' button appears depending on criterion
    - Project List page
        - Product cards for variant products (when selected and added to the list)
    - PDF displays variant sku of products, quantity and length (depends on product type)

Helpers created:
    - setExpiry() → Stores a set expiration on products added to list
    - getExpiry() → Retrieves desired list 
    - checkStorage() → Creates/Loads array into list location
    - updateCounter() → Displays num of products added to the project list
    - convertToBase64() → Encodes url as printable string (text)
    - createMargins(): Used in PDF file (type: JSPDF)
    - setLineHeight(): Used in PDF file (type: JSPDF)
    - setFooterLineHeight(): Used in JSPDF file
    - createUpdate() → Displays a notification when a product is added to the list
    - createDownloadAnchor() → Creates link to download PDF file
    - openPreview() → Creates and designs preview window of PDF file
    - viewPDF() → Opens file in a new window
    - downloadPDF() → Downloads file
    - verifyLengthInput(), checkPhoneInput(), checkEmailInput() → Raises errors when invalid input is entered

Main Functions:
    - renderBoard() → Builds the layout of the project list page (when its empty or in use) 
        and builds the layout of product cards (when a product is added to the list)
    - generatePDF() → Builds a PDF. Contains information pulled from users' project list.


Note:
*Assumes user is not logged in.
- Renders at theme.liquid, Line 426
- ttl stands for time to live

=========================================================================================*/

getExpiry('productExpiry');

function setExpiry(key, value, ttl) {
    const now = new Date();
    const productObj = {
        value: value,
        expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(productObj));
}

function getExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null
    }

    const productObj = JSON.parse(itemStr);
    const now = new Date();
    if ( now.getTime() > productObj.expiry) {
        localStorage.removeItem(key);
        localStorage.removeItem('projectItems');
        return null
    }
    return productObj.value;
}

function checkStorage() {
    let projectItems; // Inititalises variable     
    const temp = localStorage.getItem('projectItems'); 

    if (temp == null) { 
        projectItems = []; // Creates a new empty array
    } else {
        projectItems = JSON.parse(temp); // Converts information into an array and loads it
    }
    return projectItems;
}

function updateCounter(projectItems) {
    let numOfProducts = projectItems.reduce((total , item) => total + parseInt(item.variantQuantity), 0); // Returns number of products in array
    const myProjectBtn = document.querySelector('.project-button-counter'); 
    if (!myProjectBtn) return; 

    myProjectBtn.textContent = numOfProducts;

    if (numOfProducts === 0) {
	    document.querySelector('.project-button-counter').style.display = 'none';
    } else {
        if (numOfProducts >= 1) {
            document.querySelector('.project-button-counter').style.display = 'block';
        }
    }
}

function convertToBase64(blob) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve(reader.result);
        };
        reader.readAsDataURL(blob);
    })
}

function createMargins(doc) {
    const margin = 12.7; // 0.5 inch in mm 
    const pageHeight = doc.internal.pageSize.getHeight(); 
    const pageWidth = doc.internal.pageSize.getWidth();

    const top = margin;
    const bottom = pageHeight - margin;
    const left = margin;
    const right = pageWidth - margin;

    return {
        top, bottom, left, right
    }; 
}

function setLineHeight() {
    const rows = [];
    let y = 46; // Starting point
    for (let i = 0; i < 3; i++) {
        y += 6;
        rows.push(y);
    }
    return rows;
}

function setFooterLineHeight() {
    const rows = [];
    let y = 264; // Starting point
    for (let i = 0; i < 4; i++) {
        y += 6;
        rows.push(y);
    }
    return rows;
}

function createUpdate(message, eventType, duration) {
    // Displays notification outcome
    let output = {
        success: `<span class="update-display">product-notification</span>`,
        error: `<span class="update-display">product-notification</span>`,
        info: `<span class="update-display">product-notification</span>`,
    };

    // Creates notification layout
    let box = document.createElement("div");
    box.classList.add("update", `update-${eventType}`);
    box.innerHTML=`<div class="update-content-wrapper">
                        <div class="update-message">${message}</div>
                        <div class="update-progress"></div>
                    </div>`;
    duration = duration || 3000;
    let boxProgress = box.querySelector(".update-progress");
    boxProgress.style.animationDuration = `${duration/1000}s`;

    let updatedAlready = document.body.querySelector(".update");
    if (updatedAlready) {
        updatedAlready.remove();
        boxProgress.style.animationDuration = "0s";
    } 

    document.body.appendChild(box);
}

if (document.querySelector('.add-to-project-list-btn')) {
    (function() {
        let addToProjButton = document.querySelector('.add-to-project-list-btn'); // Finds button from add to project list file
        const projectItems = checkStorage();
        updateCounter(projectItems);
        
        addToProjButton.addEventListener("click", function(e) {
            const productObj = { // creates a new object that contains id, sku, title & image
                productId: e.currentTarget.dataset.id,
                productSku: e.currentTarget.dataset.sku,
                productTitle: e.currentTarget.dataset.title,
                productImage: e.currentTarget.dataset.selectedVariantImage ||  e.currentTarget.dataset.image,
                productDescription: e.currentTarget.dataset.description,
                productUrl: e.currentTarget.dataset.url,
                variantId: e.currentTarget.dataset.selectedVariantId,
                variantTitle: e.currentTarget.dataset.selectedVariant,
                variantSku: e.currentTarget.dataset.selectedVariantSku,
                variantLength: e.currentTarget.dataset.selectedLength,
                variantQuantity: e.currentTarget.dataset.selectedQuantity,
                ledDetails: e.currentTarget.dataset.ledDetails,
                hasLength: e.currentTarget.dataset.hasLength,
            }

            const displaySku = productObj.variantSku || productObj.productSku ;
            const findProduct = projectItems.find(p => p.productId === e.currentTarget.dataset.id && p.variantSku ===  e.currentTarget.dataset.selectedVariantSku );
            if (findProduct) {
                findProduct.variantQuantity = parseInt(findProduct.variantQuantity) + parseInt(productObj.variantQuantity);
                localStorage.setItem('projectItems', JSON.stringify(projectItems));
                updateCounter(projectItems);
                createUpdate(`Product ${ displaySku } has already been added.`, "error", 5000);
            } else {
                projectItems.push(productObj); // Adds all variant details into projectItems array
                localStorage.setItem('projectItems', JSON.stringify(projectItems)); // Save updated array into local storage
                updateCounter(projectItems);
                createUpdate(`Product ${ displaySku } is added.`, "success", 5000);
                if (!getExpiry('productExpiry')) {
                    setExpiry('productExpiry', true, 604800000); // Sets an expiry date of 7 days for products without one
                }
            } 
        });
    })();
}


function renderBoard() {
    const temp = localStorage.getItem('projectItems'); 
    const tempArr = temp ? JSON.parse(temp) : [];

    if (tempArr.length === 0) {
        document.querySelector('.empty-state').style.display = 'flex';
        document.querySelector('.form-container').style.display = 'none';
        document.querySelector('.board').style.display = 'none';
        document.querySelector('.continue-btn').style.display = 'none';
        document.querySelector('.reset-list-btn').style.display = 'none';
        document.querySelector('.explore-btn').style.display = 'flex';
        document.querySelector('.download-file').style.display = 'none';
        document.querySelector('.view-file').style.display = 'none';
        document.querySelector('.divider').style.display = 'none';
    } else {
        document.querySelector('.empty-state').style.display = "none";
        document.querySelector('.form-container').style.display = 'block';
        document.querySelector('.board').style.display = 'flex';
        document.querySelector('.continue-btn').style.display = 'flex';
        document.querySelector('.reset-list-btn').style.display = 'flex';
        document.querySelector('.explore-btn').style.display = 'none';
        document.querySelector('.download-file').style.display = 'flex';
        document.querySelector('.view-file').style.display = 'flex';
        document.querySelector('.board').innerHTML = '';
        
        tempArr.forEach(element => {
            const displaySku = element.variantSku || element.productSku ;
            const displayId = element.variantId || element.productId;
            const newCard = document.createElement('div');
            
            newCard.dataset.id = element.productId;
            newCard.dataset.variantId = element.variantId;
            newCard.className = 'product-card';
            newCard.innerHTML =  `
                <div class="card-wrapper">
                    <div class="card-container"> 
                        <div class="card__item one-half">
                            <a href="${element.productUrl}"><img class="product-image" src="${element.productImage}"></a>
                        </div>
                        <div class="card__item one-half-right">
                            <h4 class="product-heading">
                                <a href="${element.productUrl}">${element.productTitle}</a>
                            </h4>
                            <p class="product-sku">Part Number: ${displaySku.replace(/\(.*\)/g, '').trim()}</p>
                            ${element.variantTitle? `<p class="product-part-name">Part Name: ${element.variantTitle}</p>` : ''}
                            <div class="quantity-wrapper">
                                <div class="quantity-group">
                                    <p class="quantity-label">Quantity</p>
                                    <div class="quantity-container">
                                        <button class="decrement-btn">-</button>
                                        <input name="number" type="number" min="1" value="${element.variantQuantity}" class="quantity-counter"></input>
                                        <button class="increment-btn">+</button>    
                                    </div>
                                </div>
                                <div class="length-group">
                                    ${element.hasLength === 'true' ?
                                        ` <p class="product-length-label">Length per Metre</p>
                                        <div class="length-field">
                                            <button class="length-decrement-btn">-</button>
                                            <input name="number" type="number" min="1" value="${element.variantLength}" class="length-counter"></input>
                                            <button class="length-increment-btn">+</button>
                                        </div>` : ''}
                                </div>
                            </div>  
                        </div>
                        <div class="delete-container">
                            <button class="delete-btn" data-id="${displayId}" aria-label="delete-product">x</button>
                        </div>  
                    </div>
                </div>
            `
            
            document.querySelector('.board').appendChild(newCard);
            
            const cardLengthEdit = newCard.querySelector(".length-counter");
            const quantityLengthEdit = newCard.querySelector(".quantity-counter");

            if (cardLengthEdit) {
                cardLengthEdit.addEventListener("input", function(e) {
                    let projectItems = checkStorage();
                    const found = projectItems.find(p => p.variantId === element.variantId);
                    
                    if (found) {
                        found.variantLength = e.target.value;
                    }
                    localStorage.setItem('projectItems', JSON.stringify(projectItems));
                    updateCounter(projectItems);
                });
            }

            if (quantityLengthEdit) {
                quantityLengthEdit.addEventListener("input", function(e) {
                    checkInput(e.target, 'quantity-counter');
                });
            }

        });
    }
}


if (document.querySelector('.board')) {
    renderBoard();
    let board = document.querySelector('.board');
    const projectItems = checkStorage();
    updateCounter(projectItems);

    board.addEventListener("click", function(e) {
        const card = e.target.closest('.product-card');
        if (!card) return;

        const variantId = card.dataset.variantId;
        const counter = card.querySelector('.quantity-counter');
        const projectItems = checkStorage();
        const found = projectItems.find(p => p.variantId === card.dataset.variantId);
        

        if (e.target.classList.contains('decrement-btn')) {
            counter.stepDown();
        }

        if (e.target.classList.contains('increment-btn')) {
            counter.stepUp();
        }

        if (found) {
            found.variantQuantity = counter.value;
        }

        // length button 
        const lengthCounter = card.querySelector('.length-counter'); 
        if (lengthCounter) {
            if (e.target.classList.contains('length-decrement-btn')) {
                lengthCounter.stepDown();
            } 

            if (e.target.classList.contains('length-increment-btn')) {
                lengthCounter.stepUp();
            }

            if (found) {
                found.variantLength = lengthCounter.value;
            }
        }

        localStorage.setItem('projectItems', JSON.stringify(projectItems));
        updateCounter(projectItems);
    })


    let deleteFromProjectBtn = document.querySelector('.board'); 

    deleteFromProjectBtn.addEventListener("click", function(e) {
        if (e.target.classList.contains('delete-btn')) {
            let projectItems = checkStorage();
            projectItems = projectItems.filter((item) => (item.variantId || item.productId) !== e.target.dataset.id);
            localStorage.setItem('projectItems', JSON.stringify(projectItems)); // Save updated array into local storage
            updateCounter(projectItems);
            renderBoard();
        }
    });
}

let resetList = document.querySelector('.reset-list-btn');
if (resetList) {
    resetList.addEventListener("click", function(e) {
        let projectItems = checkStorage();
        projectItems = projectItems.filter((item) => item.removeItem );
        localStorage.setItem('projectItems', JSON.stringify(projectItems)); // Save updated array into local storage
        updateCounter(projectItems);
        renderBoard();
    })
}

// Ensures data persists when page is refreshed
const exists = document.querySelector('.project-button-counter');

if (exists) {
    const projectItems = checkStorage();
    updateCounter(projectItems); 
}

function getIncludedLed(ledInformation, variantSku) {
    const temp = document.createElement('div');
    temp.innerHTML = ledInformation;   // Gets all the information 
    const rows = temp.querySelectorAll('tr'); // Finds all rows (,tr>) and grab them as a list
    if (rows.length === 0) { return ''; }
    const headerRow = rows[0]; // Stores row line
    const headerCell = headerRow.querySelectorAll('td'); // Stores all header titles in the row
    
    // Goes by Column first
    let ledColIndex = -1; // Acts as a placeholder
    headerCell.forEach((cell, index) => {   // Iterates through each header cell and passes cell area and indexposition
        if (cell.textContent.trim() === 'Included LED') { // Retrieves markup text i.e. Included LED
            ledColIndex = index;    // Stores cell's position number
        }
    })

    if (ledColIndex === -1) {
        console.warn("Included LED column not found");
        return '';
    }

    // Then goes by Row
    for (let i =1; i < rows.length; i++) { // Starts at 1 to skip header row
        const row = rows[i];// Row defines current row within the loop iteration 
        const rowCells = row.querySelectorAll('td');    // Stores the first cell of the row
        if (rowCells[0].textContent.replace(/\\n/g, "").trim() === variantSku) {    // Checks if first cell of the row matches variantSku
            const ledCell = rowCells[ledColIndex]; // Stores desired led information based on its position from rowCells
             if (!ledCell) {
                console.warn(
                    "LED cell missing",
                    { variantSku, ledColIndex, rowCells }
                );
                return '';
            }
            const ledHtml = ledCell.innerHTML
                            .replace(/<br\s*\/?>/gi, ' ') // Replaces raw html content -- <br> with a space
                            .replace(/\\n/g, ' ')
                            .trim(); 
            const ledText = ledHtml
                            .replace(/<[^>]*>/g, '')        // Removes remaining tag and trims excess spaces at the beginning or ending
                            .replace(/&nbsp;/gi, ' ')
                            .trim();
            return ledText;     // Gives the answer back and stops the function
        }
    }
    return ''; // Returns an empty string if no matching row was found
}

async function generatePDF() {
    const { jsPDF } = window.jspdf; // Extracts jsPDF from window jsPDF
    const doc = new jsPDF({
        compress: true 
    }); // Creates a new jsPDF document by making an instance of jsPDF

    const m = createMargins(doc); // Passes doc as a parameter to retrieve function
    const projectItems = checkStorage();
    const width = doc.internal.pageSize.getWidth();
    const height = doc.internal.pageSize.getHeight();

    doc.setFillColor(255);
    doc.rect(0, 0, width, height, "F");

    doc.setFillColor(185);
    doc.rect(0, 0, width, 30, "F");

    // Initialises and creates logo
    const response = await fetch ("https://cdn.shopify.com/s/files/1/1760/2029/files/Havit-Logo-White.png?v=1782872329"); // Fetches logo URL path
    const blob = await response.blob(); // Turns response into a binary data object
    const base64 = await convertToBase64(blob);
    doc.addImage(base64, 'PNG', m.left, 8, 25, 17);

    // Stores the input value of users'details
    const projInfo = document.querySelector('#project-name').value;
    const nameInfo = document.querySelector('#name').value;
    const phoneInfo = document.querySelector('#phone').value;
    const emailInfo = document.querySelector('#email').value;
    
    // Right section
    doc.setTextColor(255);
    doc.setFontSize(15);
    doc.setFont('helvetica', 'bold');
    doc.text("Project List", m.right, 15 , {align: "right"});
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12)
    doc.text(projInfo, m.right, 22 , {align: "right"});

    // Initialising and creating Product Images 
    const productImage = await Promise.all(
        projectItems.map(async (item) => { 
            const photo = await fetch(item.productImage); // Fetches product image
            const photoBlob = await photo.blob(); // Converts into binary object
            const productPhoto = await convertToBase64(photoBlob); // Turns into base 64
            return productPhoto;
        })
    )

    doc.setTextColor(0);
    doc.setFontSize(13);
    doc.setFont("helvetica", 'bold');
    doc.text("Summary", m.left, 43,{ align: 'left'}); 

    const infoX = m.left + 35;  // Positions information for x coordinate
    const rows = setLineHeight();
    
    // Form 
    doc.setTextColor(0);
    doc.setFont("helvetica", 'bold');
    doc.setFontSize(10);
    doc.text("Project Name:", m.left, rows[0], {align: "left"});
    doc.text("Name:",  m.left, rows[1], {align: "left"});
    doc.text("Phone Number:", m.left, rows[2], {align: "left"});
    doc.text("Email:", (m.left + 100), rows[0], {align: "left"});             

    doc.setFont("helvetica", 'normal');
    doc.text(projInfo, infoX, rows[0], {align: "left"});
    doc.text(nameInfo, infoX, rows[1], {align: "left"});
    doc.text(phoneInfo, infoX, rows[2], {align: "left"});
    doc.text(emailInfo, (m.left + 135), rows[0], {align: "left"});

    // Date and time
    doc.setFont('helvetica', 'normal');
    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    let hours = date.getHours();
    let min = date.getMinutes();
    let sec = date.getSeconds().toString().padStart(2, '0');

    doc.setFont("helvetica", 'bold');
    doc.text("Generated:", (m.left + 100), rows[1], {align: 'left'});
    doc.setFont("helvetica", 'normal');
    doc.text(`${day}/${month}/${year} ${hours}:${min}:${sec}`, (m.left + 135), rows[1], {align: 'left'});

    // Table on products added ]
    doc.setCharSpace(0.1);
    doc.setLineHeightFactor(1.5);
    doc.autoTable({
        startY: 73, 
        head: [["Product", "SKU", "Description", "Quantity", ]],
        body: projectItems.map((item) => {
            let partSku = item.variantSku || item.productSku;
            let ledString = getIncludedLed(item.ledDetails, partSku);
            const regexCheck = /-(\d+)M$/;
            const lengthMatch = (item.variantSku || "").match(regexCheck);
            let rollLength = "";

            if (lengthMatch) {
                rollLength = lengthMatch[1]; // Stores matched pattern (when sku has defined pattern)
                rollLength += ' metre'; // Takes stored number and adds metre to the word 
            }

            const normalDisplay = `${item.variantQuantity? item.variantQuantity +'x' : ""}\n${item.hasLength === 'true' ? item.variantLength + ' metre': ""}`;
            let finalQuantityDisplay = normalDisplay;
            if (rollLength.trim()) {
                finalQuantityDisplay = `${item.variantQuantity + 'x'}\n${rollLength}`;
            }

            return [
                "", // didDrawCell handles image column
                `${item.variantTitle? item.variantTitle + ":" : ""}\n${(item.variantSku || item.productSku || "")
                    // Removes excess characters and adds LED information on a newline
                    .replace(/\(.*?\)/g, "")}${ledString? '\nIncluded LED: ' + ledString : ''}`,
                // Strips information of remaining tags, whitespaces, specific strings and collapses two or more consecutive newlines into one.
                item.productDescription
                    .replace(/<[^>]*>/g, "")
                    .trim()
                    .replace(/Maximum length.*\n?/gi, "")
                    .trim()
                    .replace(/\n{2,}/g, '\n'),
                finalQuantityDisplay,
            ]
        }),
        margin: { bottom: 48, left: m.left, right: m.left },
        theme: 'plain',
        headStyles: {
            textColor: 0,
            fillColor: 255,
            halign: 'left',
            fontSize: 10
        },
        bodyStyles: {lineWidth: 0, minCellHeight: 60, fontStyle:'normal', fontSize: 8, valign: 'middle', textColor: 0, lineHeight: 3},
        tableWidth: 'auto',
        columnStyles: {
            0: { cellWidth: 38},
            2: { cellWidth: 70},
            3: { halign: 'center'}
        },

        didDrawCell: function(cell) {
            // Draws border
            doc.setDrawColor(200);
            doc.setLineWidth(0.2);
            doc.line(
                cell.cell.x,
                cell.cell.y + cell.cell.height,
                cell.cell.x  + cell.cell.width,
                cell.cell.y + cell.cell.height
            );

            // Draws product image(s)
            if (cell.row.section === 'body' && cell.column.index === 0) {
                const image = productImage[cell.row.index];
                if (!image) return ;
                doc.addImage(
                    image,
                    'UNKNOWN',
                    cell.cell.x + (cell.cell.width/2) - 15,
                    cell.cell.y + (cell.cell.height/2) - 15,
                    30, 
                    30 
                );
            }  
        },
    });
    doc.setLineHeightFactor(1.15);
    doc.setCharSpace(0);
    // Initalises QR Reseller Image
    const resellerLocator = await fetch ("https://cdn.shopify.com/s/files/1/0080/5067/1734/files/HL_Store_Locator.png?v=1783896628"); // Fetches logo URL path
    const resellerBlob = await resellerLocator.blob();
    const storeImg = await convertToBase64(resellerBlob);

    const pageCount = doc.getNumberOfPages();
    const rowsY = setFooterLineHeight();

    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        // Footer 
        doc.setTextColor(0);
        doc.setFontSize(10);
        doc.text("Havit Lighting", m.left, rowsY[0], {align: "left"});
        doc.text("143 Beauchamp Road Matraville NSW 2036", m.left, rowsY[1], {align: "left"});
        doc.text("+61 (02) 9381 8300", m.left, rowsY[2], {align: "left"});
        doc.text("Enquiries@havit.com.au", m.left, rowsY[3], {align: "left"});
        doc.addImage(storeImg, 'PNG', (m.right - 23), 265, 23, 23); // Positions QR Code
        doc.setFontSize(10);
        doc.text("Scan for Reseller Locator", 163, 275, { align: 'center', maxWidth: 15 }); 
    }

    var fileName = projInfo + "-Project-List.pdf";

    doc.setProperties({ 
        title: fileName,
        author: 'Havit Lighting',
        subject: 'Havit Lighting', 
        creator: 'Havit Lighting'
    }); 

    return {
        doc: doc,
        fileName: fileName
    };
}


function createDownloadAnchor(blob, fileName) {
    var pdfUrl = URL.createObjectURL(blob);
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) { 
        window.open('','_blank');
    }

    var anchor = document.createElement('a');
    anchor.href = pdfUrl;
    anchor.download = fileName;
    anchor.setAttribute('download', fileName);
    anchor.style.display = 'none';

    document.body.appendChild(anchor);
    anchor.click();

    setTimeout(function () {
        document.body.removeChild(anchor);
        URL.revokeObjectURL(pdfUrl);
    }, 700);
}

function openPreview(blob, fileName) {
    var browserUrl = URL.createObjectURL(blob);
    var previewWindow = window.open('', '_blank');
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!previewWindow) {  // Raises a comment
        alert('Please allow pop-ups to preview the PDF');
        return;
    }

    // Embeds a window within a new window to display pdf
    previewWindow.document.title = fileName;
    var preview = previewWindow.document.createElement('iframe');
    var previewBar = previewWindow.document.createElement('div');
    previewBar.className = 'project-tool-preview-bar';
    
    var previewName = previewWindow.document.createElement('div');
    previewName.className = 'project-tool-preview-name';

    var downloadFile = previewWindow.document.createElement('a');
    downloadFile.className = 'project-tool-download-file';
    downloadFile.href = browserUrl;
    downloadFile.download = fileName;
    downloadFile.setAttribute('download', fileName);
    downloadFile.textContent = 'Download PDF';

    var iframe = previewWindow.document.createElement('iframe');
    iframe.src = browserUrl + '#toolbar=0&navpanes=0&scrollbar=1';
    iframe.title = fileName;

    var customStyle = previewWindow.document.createElement('style');
    customStyle.textContent =
    'html,body{margin:0;height:100%;background:#1f1f1f;font-family:Arial,sans-serif;overflow:hidden;}' +
    '.project-tool-preview-bar{height:54px;background:#030303;color:#fff;display:flex;align-items:center;justify-content:space-between;gap:16px;padding:0 18px;box-sizing:border-box;border-bottom:1px solid #333;}' +
    '.project-tool-preview-name{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:13px;font-weight:700;}' +
    '.project-tool-download-file{background:#fff;color:#000;text-decoration:none;font-size:12px;font-weight:800;padding:10px 16px;text-transform:uppercase;letter-spacing:.08em;white-space:nowrap;}' +
    'iframe{width:100%;height:calc(100% - 54px);border:0;background:#fff;display:block;}';

    previewWindow.document.head.appendChild(customStyle);
    previewBar.appendChild(previewName);
    previewBar.appendChild(downloadFile);
    previewWindow.document.body.appendChild(previewBar);
    previewWindow.document.body.appendChild(iframe);
}

async function viewPDF() {
    var built = await generatePDF();
    if (!built) return; 

    var blob = built.doc.output('blob');
    openPreview(blob, built.fileName);
}

async function downloadPDF() {
    var built = await generatePDF();
    if (!built) return;

    var blob = built.doc.output('blob');
    createDownloadAnchor(blob, built.fileName); 
}

const downloadBtn = document.querySelector('.download-file');
const form = document.querySelector('.user-details');
//function getInputValues() {}

if (downloadBtn) {
    downloadBtn.addEventListener("click", function() {
        const phoneValue = document.getElementById('phone').value;
        const emailValue = document.getElementById('email').value;
        if (form.checkValidity() && checkPhoneInput(phoneValue) && checkEmailInput(emailValue)) {
            downloadPDF();
        } else {
            form.reportValidity();
            return;
        }
    })
}

// Check view button bug bug
const viewBtn = document.querySelector('.view-file');
if (viewBtn) {
    viewBtn.addEventListener("click", function() {
        const phoneValue = document.getElementById('phone').value;
        const emailValue = document.getElementById('email').value;
        if (form.checkValidity() && checkPhoneInput(phoneValue) && checkEmailInput(emailValue)) {
           viewPDF();
        } else {
            form.reportValidity();
            return;
        }
    })
} 

/* add-to-project-tool.liquid  */ 
function verifyLengthInput(value) {
    const errorElement = document.getElementById("error-exception");
    const numerical =/^[0-9]*\.?[0-9]+$/;

    if (numerical.test(value)) {
        errorElement.textContent = '';
        return true;
    } else {
        errorElement.textContent = "Please enter a valid number";
        return false;
    }  
}

const lengthInput = document.getElementById("length");
if (lengthInput) {
    lengthInput.addEventListener("input", function(e) {
        const target = e.currentTarget.value;
        verifyLengthInput(target);
    })
}

function checkPhoneInput(value) {
    const errorElement = document.getElementById("phone-exception");
    const convertedNumber = Number(value);
    if (Number.isNaN(convertedNumber)) {
        errorElement.textContent = "Please enter a valid phone number." ;
        return false;
    } else {
        errorElement.textContent = '';
        return true;
    }  
}

const phoneInput = document.getElementById("phone");
if (phoneInput) {
    phoneInput.addEventListener("input", function(e) {
        const target = e.currentTarget.value;
        checkPhoneInput(target);
    })
}

function checkEmailInput(value) {
    const errorElement = document.getElementById("email-exception");
    const emailPattern = /^[^\s@]+@[^\s@]+\.(com|com\.au)$/;

    if (!emailPattern.test(value)) {
        errorElement.textContent = "Please enter a valid email";
        return false;
    } else {
        errorElement.textContent = '';
        return true;
    }  
}

const emailField = document.getElementById("email");
if (emailField) {
    emailField.addEventListener("input", function(e) {
        const target = e.currentTarget.value;
        checkEmailInput(target);
    })
}

/*
document.getElementById("email").addEventListener("input", function(e) {
    const target = e.currentTarget.value;
    checkEmailInput(target);
})*/


{{ 'theme.js' | asset_url | script_tag }}